export default {
    setDataSegmentList(state, data) {
        state.dataSegmentList = data
    },
    setDataSegmentId(state, data) {
        if (data) {
            localStorage.setItem('activeDataSegmentId', data)
        } else {
            localStorage.removeItem('activeDataSegmentId')
        }
        state.dataSegmentId = data
    },
    setDataSegmentDetail(state, data) {
        state.dataSegmentDetail = data
    },
}
